import { FullScreenLoading } from "@senciamatch/frontend/components/FullScreenLoading";
import { trpc } from "@senciamatch/frontend/libs/trpc";
import { Link, useParams } from "react-router-dom";

export const StaffWorkScorePage = () => {
  const { id } = useParams<{ id: string }>();

  const { data, isLoading, error } = trpc.getStaffWorkScores.useQuery({
    id: id || "",
  });

  if (!id) {
    return <div>IDが指定されていません</div>;
  }

  if (isLoading) {
    return <FullScreenLoading />;
  }

  if (error) {
    return <div>エラーが発生しました: {error.message}</div>;
  }

  if (!data) {
    return <div>データが見つかりません</div>;
  }

  return (
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <Link to="/staffs" className="text-blue-600 hover:underline">
          ← スタッフ一覧に戻る
        </Link>
      </div>

      <h1 className="text-2xl font-bold mb-6">勤務スコア確認 - {data.staff.name}</h1>

      <div className="mb-4 text-gray-600">
        <p>※スコアが高いほどマッチング優先度が高くなります</p>
      </div>

      {data.scores.length === 0 ? (
        <div className="bg-gray-100 p-4 rounded">
          <p>勤務実績のある物件がありません</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                  物件番号
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                  物件名
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                  住所
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                  会社
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                  スコア
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {data.scores.map((score) => (
                <tr key={score.buildingId} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{score.buildingCasNaviId}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    <Link to={`/buildings/${score.buildingId}/score`} className="text-blue-600 hover:underline">
                      {score.buildingName}
                    </Link>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900">{score.buildingAddress}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{score.companyName}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <span
                      className={
                        score.score >= 500 ? "text-green-600" : score.score >= 100 ? "text-yellow-600" : "text-red-600"
                      }
                    >
                      {score.score}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
